import React, { createContext, useContext, ReactNode } from "react";

interface HeaderVisibilityContextValue {
  /**
   * Whether the header is currently visible
   * Used for dynamic positioning of sticky elements
   */
  headerVisible: boolean;
}

const HeaderVisibilityContext = createContext<HeaderVisibilityContextValue | null>(null);

interface HeaderVisibilityProviderProps {
  children: ReactNode;
  headerVisible: boolean;
}

/**
 * HeaderVisibilityProvider - Provides header visibility state to child components
 *
 * Used by layouts with hideOnScroll feature to communicate header visibility
 * to components like SearchFilterBar that need to adjust their position dynamically
 */
export function HeaderVisibilityProvider({
  children,
  headerVisible,
}: HeaderVisibilityProviderProps) {
  return (
    <HeaderVisibilityContext.Provider value={{ headerVisible }}>
      {children}
    </HeaderVisibilityContext.Provider>
  );
}

/**
 * useHeaderVisibility - Hook to access header visibility state from context
 *
 * @returns Header visibility state, or null if context is not available
 */
export function useHeaderVisibility(): HeaderVisibilityContextValue | null {
  return useContext(HeaderVisibilityContext);
}

